export function getHCPFlowErrorMessage(error: unknown, fallback: string): string {
  if (!error) return fallback
  if (typeof error === 'string') return error

  const record = error as Record<string, unknown>

  if (record.response && typeof record.response === 'object') {
    const response = record.response as Record<string, unknown>
    const status = response.status
    const data = response.data

    if (data && typeof data === 'object') {
      const body = data as Record<string, unknown>
      const message = body.error ?? body.message
      if (message) {
        return status ? `${String(message)} (HTTP ${status})` : String(message)
      }
    }
  }

  const message = record.error ?? record.message
  if (message) {
    return record.status ? `${String(message)} (HTTP ${record.status})` : String(message)
  }

  return fallback
}
